import { render } from "./MassTransfertsPage.vue?vue&type=template&id=cf15bfa2&ts=true"
import script from "./MassTransfertsPage.vue?vue&type=script&lang=ts"
export * from "./MassTransfertsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__